import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about">
      <section className="about-hero section-padding">
        <div className="container-narrow">
          <h1 className="heading-1">About</h1>
        </div>
      </section>

      <section className="about-intro section-padding-small">
        <div className="container-narrow">
          <p className="body-large">
            Megha Mehta is a Creative Head, Stylist, and Visual Strategist working across 
            fashion, e-commerce, and brand storytelling.
          </p>
          <p className="body-large" style={{ marginTop: '32px' }}>
            Her work is grounded in clarity — in building visual languages that feel intuitive, 
            consistent, and emotionally resonant, while remaining commercially effective.
          </p>
        </div>
      </section>

      <section className="about-work section-padding-small">
        <div className="container-narrow">
          <h2 className="heading-2">How I Work</h2>
          <p className="body-regular" style={{ marginTop: '24px' }}>
            I approach fashion visuals as systems rather than isolated moments. Every campaign, 
            shoot, or content piece is part of a larger narrative — one that must remain coherent 
            across platforms, seasons, and consumer touchpoints.
          </p>
          <p className="body-regular" style={{ marginTop: '24px' }}>
            My process is rooted in observation, restraint, and precision. I focus on what to include, 
            but just as intentionally, what to leave out.
          </p>
        </div>
      </section>

      <section className="about-philosophy section-padding-small">
        <div className="container-narrow">
          <h2 className="heading-2">Philosophy</h2>
          <div className="philosophy-statements">
            <p className="body-large">Good fashion imagery does not need to be loud to be powerful.</p>
            <p className="body-large">It needs to be thoughtful.</p>
            <p className="body-large">Consistent.</p>
            <p className="body-large">And honest.</p>
          </div>
          <p className="body-regular" style={{ marginTop: '32px' }}>
            I believe visuals should support the product, not overpower it — creating a sense of ease, 
            trust, and longevity.
          </p>
        </div>
      </section>

      <section className="about-approach section-padding-small">
        <div className="container-narrow">
          <h2 className="heading-2">Approach</h2>
          <p className="body-regular" style={{ marginTop: '24px' }}>
            My work sits at the intersection of creative instinct and structured thinking. I translate 
            trends into narratives, and narratives into repeatable visual systems that brands can grow with.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
